
export default [
  { // 대회안내
    index:true,
    lazy: async ()=>({Component:(await import('./BasicInfo/BasicInfo')).default })
  }, 
  { // 신청 목록
    path:'registration',
    lazy: async ()=>({Component:(await import('./Registration/Registration')).default })
  },
  { // 경기현황
    path:'race-view',
    lazy: async ()=>({Component:(await import('./RaceView/RaceView')).default })
  },
]